module.exports = __webpack_public_path__ + "static/bs-162682a801338ba7b03c6a7255425070.jpg";